<template>
    <div>
        <div v-for="(item, index) in list" :key="index">
            <h3>{{item.title}}</h3>
            <el-row class="infobox">
                <el-row v-for="(obj, idx) in item.items" :key="idx">
                    {{obj}}
                </el-row>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    data: vm=>({
        list: []
    }),
    created(){
        this.getList()
    },
    methods: {
        getList(){
            this.$axios.get("/mmv/help.json").then(({data}) => {
                this.list = data.helps
            });
        }
    }
}
</script>
<style scoped>
.infobox{
    margin: 15px 0;
}
.infobox >>> .el-row{
    margin: 10px 0;
}
</style>
